/**
 * Work — the whole street at once: the opening, every shop by district and
 * the way to the contact page. The server writes it
 * (templates/site/work.html.twig); this moves it.
 *
 * @module pages/work
 */

import { $ } from '../lib/dom.js';
import * as district from '../sections/work/district.js';
import * as opening from '../sections/work/opening.js';

export function animate() {
    opening.animate($('#index'));
    district.animate($('#shops'));
}
